module.exports = "/img/7.b6a6f4.webp";